// src/pages/About.js
import React from "react";
import { useTranslation } from "react-i18next";

import { Helmet } from "react-helmet-async";

const About = () => {
  const { t } = useTranslation();


  return (
    <>
      <Helmet>
        <html lang="sr" />

        {/* Title i meta description */}
        <title>O Nama | AlphaPremiumSolutions</title>
        <meta
          name="description"
          content="Saznajte više o AlphaSolutions, našem timu stručnjaka za web dizajn i razvoj modernih web aplikacija u Srbiji."
        />
        <meta
          name="keywords"
          content="o nama, web dizajn tim, izrada sajtova, web razvoj, Srbija"
        />
        <meta name="author" content="AlphaPremiumSolutions" />
        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="O Nama | AlphaPremiumSolutions" />
        <meta
          property="og:description"
          content="Upoznajte tim profesionalaca koji razvijaju moderne i SEO optimizovane web sajtove za firme u Srbiji."
        />
        <meta property="og:url" content="https://alphapremiumsolutions.com/about" />
        <meta property="og:locale" content="sr_RS" />
        <meta property="og:image" content="https://alphapremiumsolutions/og-image.jpg" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="O Nama | AlphaPremiumSolutions" />
        <meta
          name="twitter:description"
          content="Tim stručnjaka za web dizajn i izradu sajtova u Srbiji – AlphaPremiumSolutions"
        />
        <meta name="twitter:image" content="https://tvoj-domen.rs/images/og-image.jpg" />

        {/* Canonical */}
        <link rel="canonical" href="https://alphapremiumsolutions.com/about" />

        {/* JSON-LD – LocalBusiness / About */}
        <script type="application/ld+json">
          {`
        {
          "@context": "https://schema.org",
          "@type": ["LocalBusiness", "ProfessionalService"],
          "@id": "https://alphapremiumsolutions.com/#business",
          "name": "AlphaPremiumSolutions",
          "url": "https://alphapremiumsolutions.com",
          "logo": "https://alphapremiumsolutions.com/logo.png",
          "image": "https://alphapremiumsolutions.com/og-image.jpg",
          "description": "Tim profesionalaca za web dizajn i izradu modernih web aplikacija u Srbiji.",
          "email": "info@alphapremiumsolutions.com",
          "telephone": "+381638597131",
          "priceRange": "€€",
          "areaServed": {
            "@type": "Country",
            "name": "Serbia"
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Beograd",
            "addressRegion": "RS",
            "addressCountry": "RS"
          },
          "sameAs": [
            "https://www.linkedin.com/company/alphapremiumsolutions",
            "https://www.instagram.com/alphapremiumsolutions",
            "https://www.facebook.com/alphapremiumsolutions"
          ],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Web Usluge",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": { "@type": "Service", "name": "Izrada Web Sajtova" }
              },
              {
                "@type": "Offer",
                "itemOffered": { "@type": "Service", "name": "SEO Optimizacija" }
              },
              {
                "@type": "Offer",
                "itemOffered": { "@type": "Service", "name": "Razvoj Web Aplikacija" }
              }
            ]
          }
        }
        `}
        </script>
      </Helmet>


      <section className="py-5 bg-light">
        <div className="container">
          {/* Header */}
          <div className="text-center mb-5">
            <h2 className="fw-bold">{t("about.t1")}</h2>
            <p className="text-muted fs-5">{t("about.t2")}</p>
          </div>

          {/* Features / Highlights */}
          <div className="row g-4">
            {/* Kartica 1 */}
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm rounded-4 p-4 hover-scale text-center">
                <div className="mb-3 fs-2">⚡</div> {/* Ikona po želji */}
                <h5 className="fw-bold">{t("clients_chose.t2")}</h5>
                <p className="text-muted mt-2">{t("clients_chose.desc2")}</p>
              </div>
            </div>

            {/* Kartica 2 */}
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm rounded-4 p-4 hover-scale text-center">
                <div className="mb-3 fs-2">⏱️</div> {/* Ikona po želji */}
                <h5 className="fw-bold">{t("clients_chose.t3")}</h5>
                <p className="text-muted mt-2">{t("clients_chose.desc3")}</p>
              </div>
            </div>

            {/* Kartica 3 */}
            <div className="col-md-6 col-lg-4">
              <div className="card h-100 border-0 shadow-sm rounded-4 p-4 hover-scale text-center">
                <div className="mb-3 fs-2">🌐</div> {/* Ikona po želji */}
                <h5 className="fw-bold">{t("clients_chose.t4")}</h5>
                <p className="text-muted mt-2">{t("clients_chose.desc4")}</p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-5">
            <h4 className="fw-bold">{t("about.t4")}</h4>
            <a href="/contact" className="btn btn-primary mt-3">{t("body.t13")}</a>
          </div>
        </div>

        {/* Hover efekat */}
        <style jsx>{`
        .hover-scale {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hover-scale:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
        }
      `}</style>
      </section>
    </>
  );
};

export default About;